var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 167.91,
    viewBox: "0 0 106.36 44.427",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.9499 -14.805)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "row6",
    transform: "matrix(.99998 0 0 .99998 10.789 -6.0178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.183,
    y: 60.338,
    width: 17.574,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#7862d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 60.338,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 60.338,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 60.338,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#4d4cff"
  })), /*#__PURE__*/React.createElement("g", {
    className: "row5",
    transform: "matrix(.99998 0 0 .99998 10.789 -6.0178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.183,
    y: 54.525,
    width: 19.547,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#9b8adb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 54.525,
    width: 17.198,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 54.525,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffd480"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 54.525,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#8080ff"
  })), /*#__PURE__*/React.createElement("g", {
    className: "row4",
    transform: "matrix(.99998 0 0 .99998 10.789 -6.0178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.183,
    y: 48.712,
    width: 21.985,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 48.712,
    width: 18.521,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 48.712,
    width: 18.521,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 48.712,
    width: 21.167,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#0200ff"
  })), /*#__PURE__*/React.createElement("g", {
    className: "row3",
    transform: "matrix(.99998 0 0 .99998 10.789 -6.0178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.183,
    y: 42.899,
    width: 16.778,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#7862d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#4c4cff"
  })), /*#__PURE__*/React.createElement("g", {
    className: "row2",
    transform: "matrix(.99998 0 0 .99998 10.789 -6.0178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.183,
    y: 37.087,
    width: 19.937,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#452f9d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#f33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffba33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#33f"
  })), /*#__PURE__*/React.createElement("g", {
    className: "row1",
    transform: "matrix(.99998 0 0 .99998 10.789 -6.0178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.183,
    y: 31.274,
    width: 19.981,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#8976d5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 31.274,
    width: 22.49,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#f66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 31.274,
    width: 21.167,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffcb66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 31.274,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#6766ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99998 0 0 .99998 10.789 -6.0178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.183,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.2969,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#0100ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m5.4775 23.136h105.31",
    fill: "none",
    stroke: "#aa9de2",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.26155
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3439,
    y: 15.199,
    width: 105.57,
    height: 43.639,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#aa9de2",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25889
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.340b04b1244402e3780cfcca147811e6.svg";
export { ForwardRef as ReactComponent };